import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  background: theme.color.background.surface
}));
